
/**
 * HornDeliver brand logo — icon-only squircle app mark.
 *
 * Rendered from /horndeliver-logo.png (1024×1024 RGBA). The mark is a
 * deep-teal squircle with a white parcel frame and a mint rising delivery
 * arrow (the original HornDeliver icon). The image contains NO text.
 *
 * Callers should pair this with a separate <BrandWordmark /> text element in
 * headers/footers/auth/legal pages for a readable app name, since the icon
 * alone does not spell out "HornDeliver".
 *
 * Size via the `className` prop (e.g. "h-8 w-8").
 */
export function Logo({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <img
      src="/horndeliver-logo.png"
      alt="HornDeliver"
      className={`object-contain ${className}`}
      draggable={false}
    />
  );
}
